export const DEFAULT_EVENT_POLL_INTERVAL_MS = 5000;
export const RUNNING_EVENT_POLL_INTERVAL_MS = 1000;
